const JOURNAL_PROMO_TOAST_STORAGE_KEY = 'fxscouts-journal-promo-toast-dismissed-until';
const JOURNAL_PROMO_TOAST_DISMISS_DAYS = 7;

const isJournalPromoToastDismissed = () => {
  const dismissedUntil = localStorage.getItem(JOURNAL_PROMO_TOAST_STORAGE_KEY);
  if (!dismissedUntil) return false;
  return Date.now() < Number(dismissedUntil);
};

const dismissJournalPromoToast = (toast) => {
  const dismissedUntil = Date.now() + (JOURNAL_PROMO_TOAST_DISMISS_DAYS * 24 * 60 * 60 * 1000);
  localStorage.setItem(JOURNAL_PROMO_TOAST_STORAGE_KEY, String(dismissedUntil));
  toast.classList.remove('is-visible');
};

const JOURNAL_PROMO_TOAST_COOKIE_BAR_GAP_PX = 20;

const updateJournalPromoToastPosition = (toast) => {
  const cookieBar = document.querySelector('.js-cookie-bar');
  const isCookieBarVisible = !!cookieBar && !cookieBar.classList.contains('is-hidden');
  if (isCookieBarVisible) {
    toast.style.bottom = `${cookieBar.offsetHeight + JOURNAL_PROMO_TOAST_COOKIE_BAR_GAP_PX}px`;
  } else {
    toast.style.removeProperty('bottom');
  }
};

const watchCookieBarForJournalPromoToast = (toast) => {
  const cookieBar = document.querySelector('.js-cookie-bar');
  if (!cookieBar) return;

  const observer = new MutationObserver(() => updateJournalPromoToastPosition(toast));
  observer.observe(cookieBar, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', () => updateJournalPromoToastPosition(toast));
};

const journalPromoToast = () => {
  const toast = document.querySelector('.js-journal-promo-toast');
  if (!toast) return;

  if (isJournalPromoToastDismissed()) return;

  toast.classList.remove('is-hidden');
  updateJournalPromoToastPosition(toast);
  watchCookieBarForJournalPromoToast(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));

  const closeButton = toast.querySelector('.js-journal-promo-toast-close');
  if (closeButton) {
    closeButton.addEventListener('click', () => dismissJournalPromoToast(toast));
  }
};

document.addEventListener('DOMContentLoaded', journalPromoToast);
